"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "lot-inventory-selector"
  }, [_vm.label ? _c("div", {
    staticClass: "selector-label"
  }, [_c("h4", [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), !_vm.inventories || !_vm.inventories.length ? _c("div", {
    staticClass: "empty-state"
  }, [_c("p", [_vm._v(_vm._s(_vm.emptyMessage))])]) : _c("div", {
    staticClass: "inventory-list"
  }, _vm._l(_vm.inventories, function (inventory) {
    var _inventory$section, _inventory$row;
    return _c("div", {
      key: inventory.id,
      staticClass: "inventory-item"
    }, [_c("div", {
      staticClass: "inventory-info"
    }, [_c("div", {
      staticClass: "inventory-location"
    }, [_c("strong", [_vm._v(_vm._s(((_inventory$section = inventory.section) === null || _inventory$section === void 0 ? void 0 : _inventory$section.name) || "Setor"))]), _vm._v(" "), _c("span", {
      staticClass: "separator"
    }, [_vm._v("→")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(((_inventory$row = inventory.row) === null || _inventory$row === void 0 ? void 0 : _inventory$row.name) || "Rua"))])]), _vm._v(" "), _c("div", {
      staticClass: "inventory-available"
    }, [_c("span", {
      staticClass: "available-label"
    }, [_vm._v("Disponível:")]), _vm._v(" "), _c("span", {
      staticClass: "available-value"
    }, [_vm._v(_vm._s(inventory.quantity || 0))])])]), _vm._v(" "), _vm.hideQuantityField === false ? _c("div", {
      staticClass: "inventory-quantity"
    }, [_c("b-field", {
      staticClass: "quantity-field",
      attrs: {
        label: _vm.quantityLabel
      }
    }, [_c("div", {
      staticClass: "quantity-controls"
    }, [_c("b-input", {
      attrs: {
        type: "number",
        placeholder: _vm.quantityPlaceholder,
        disabled: _vm.disabled,
        min: _vm.quantityMin,
        step: _vm.quantityStep
      },
      on: {
        input: function input($event) {
          return _vm.handleQuantityChange(inventory.id);
        }
      },
      model: {
        value: _vm.selectedQuantities[inventory.id],
        callback: function callback($$v) {
          _vm.$set(_vm.selectedQuantities, inventory.id, _vm._n($$v));
        },
        expression: "selectedQuantities[inventory.id]"
      }
    }), _vm._v(" "), _vm.strength ? _c("b-select", {
      attrs: {
        placeholder: "Selecione a força",
        disabled: _vm.disabled
      },
      on: {
        input: function input($event) {
          return _vm.handleStrengthChange(inventory.id);
        }
      },
      model: {
        value: _vm.selectedStrengths[inventory.id],
        callback: function callback($$v) {
          _vm.$set(_vm.selectedStrengths, inventory.id, $$v);
        },
        expression: "selectedStrengths[inventory.id]"
      }
    }, [_c("option", {
      attrs: {
        disabled: ""
      },
      domProps: {
        value: null
      }
    }, [_vm._v("\n                Selecione a força\n              ")]), _vm._v(" "), _c("option", {
      attrs: {
        value: "weak"
      }
    }, [_vm._v("\n                Fraco\n              ")]), _vm._v(" "), _c("option", {
      attrs: {
        value: "medium"
      }
    }, [_vm._v("\n                Médio\n              ")]), _vm._v(" "), _c("option", {
      attrs: {
        value: "strong"
      }
    }, [_vm._v("\n                Forte\n              ")])]) : _vm._e()], 1)])], 1) : _vm._e()]);
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;